export enum EnvironmentType {
  PRODUCTION = 'PRODUCTION',
  TEST = 'TEST',
  STAGING = 'STAGING'
}
